import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UploadImageService {

  constructor() { }

  isSizeInMegabytes(size: number, unit: string) {
	if (unit.toLowerCase() === 'kb') {
		size = size / 1024;
	}
	return size <= 1;
}

  async downloadFile(url:string, fileName:string){
	const response = await fetch(url);
	const blob = await response.blob();
	const objectUrl = window.URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.style.display = 'none';
	a.href = objectUrl;
	a.download = fileName;
	document.body.appendChild(a);
	a.click();
	window.URL.revokeObjectURL(objectUrl);
	document.body.removeChild(a);
  }

}
